import { motion } from "framer-motion";
import { headingAccents, useLanguage } from "@/i18n";

export const AccentText = ({ text, accentKey }) => {
    const { lang } = useLanguage();
    const accent = headingAccents[lang]?.[accentKey];
    if (!accent || !text.includes(accent)) return <>{text}</>;
    const idx = text.indexOf(accent);
    return (
        <>
            {text.slice(0, idx)}
            <em className="italic text-midora-red">{accent}</em>
            {text.slice(idx + accent.length)}
        </>
    );
};

export const Reveal = ({ children, delay = 0, y = 40, className = "" }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    >
        {children}
    </motion.div>
);

export const scrollToId = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    if (window.__lenis) {
        window.__lenis.scrollTo(el, { offset: -104, duration: 1.4 });
    } else {
        el.scrollIntoView({ behavior: "smooth" });
    }
};
